export const fhhDefaultState = {
    destination: '',
    destinationData: null,
    startDate: null,
    endDate: null,
    numOfBedrooms: 0,
    numOfBeds: 0,
};
